import { State } from 'src/types'
import { webTop, webBottom } from 'src/features/atoms/glove/drawer/rightThrow/firstmitt/back/web'
import { catchFace } from 'src/features/atoms/glove/drawer/rightThrow/firstmitt/back/catchFace'
import { backAroundWeb } from 'src/features/atoms/glove/drawer/rightThrow/firstmitt/back/backAroundWeb'
import { stitch } from 'src/features/atoms/glove/drawer/rightThrow/firstmitt/back/stitch'
import { backOfIndexToLittle } from 'src/features/atoms/glove/drawer/rightThrow/firstmitt/back/backOfIndexToLittle'
import { boomerang } from 'src/features/atoms/glove/drawer/rightThrow/firstmitt/back/boomerang'
import { littleHook } from 'src/features/atoms/glove/drawer/rightThrow/firstmitt/back/littleHook'
import { liningLeather } from 'src/features/atoms/glove/drawer/rightThrow/firstmitt/back/liningLeather'
import { thumbHook } from 'src/features/atoms/glove/drawer/rightThrow/firstmitt/back/thumbHook'
import { laces } from 'src/features/atoms/glove/drawer/rightThrow/firstmitt/back/lace'
import { atomsEngravedOfBackFace, atomsLabel } from 'src/features/atoms/glove/drawer/labels/atoms'
import { fingerGuardDrawer } from 'src/features/atoms/glove/drawer/rightThrow/firstmitt/back/fingerGuardDrawer'
import { edgeDrawer } from 'src/features/atoms/glove/drawer/rightThrow/firstmitt/back/edgeDrawer'
import { backOfThumbDrawer } from 'src/features/atoms/glove/drawer/rightThrow/firstmitt/back/thumbDrawer'
import { wristBeltDrawer } from 'src/features/atoms/glove/drawer/rightThrow/firstmitt/back/wristBeltDrawer'
import { liningEmbroidery, thumbEmbroideryLeftThrow } from 'src/features/atoms/glove/drawer/common/back/embroidery'
import { canvasResetter } from 'src/util/canvas'
import { firstMittChildFingerEmbroideryLeftThrow, startInversion, undoInversion } from 'src/util/canvas'
import { loopOfRingFinger } from '../../../common/back/loopOfRingFinger'

export const atomsCanvasFirstMittBackLeftThrow = async (ctx: CanvasRenderingContext2D, state: State, canvasWidth: number): Promise<void> => {
  if (!state.boomerang) return
  if (!state.thumb) return
  if (!state.underWeb) return
  // リセット
  canvasResetter(ctx)
  startInversion(ctx, canvasWidth)
  // 裏革
  liningLeather(ctx, state.linings.color)

  undoInversion(ctx, canvasWidth)
  const isEmbroideryOfLining = state.embroideries.some((x) => x.position.value === 'leatherLiningFirst')
  // 平裏への刺繍
  if (isEmbroideryOfLining) {
    liningEmbroidery(
      ctx,
      state.embroideries.find((e) => e.position.value === 'leatherLiningFirst'),
      210,
      -65
    )
  }

  const isEmbroideryOfLiningSecond = state.embroideries.some((x) => x.position.value === 'leatherLiningSecond')
  // 平裏への刺繍
  if (isEmbroideryOfLiningSecond) {
    liningEmbroidery(
      ctx,
      state.embroideries.find((e) => e.position.value === 'leatherLiningSecond'),
      215,
      -25
    )
  }

  startInversion(ctx, canvasWidth)

  //
  if (state.loopOfRingFinger.value === 'loopOfRingFinger') {
    loopOfRingFinger(ctx, state.loopOfRingFingerColor?.color, state.stitch?.color)
  }

  // 捕球面
  catchFace(ctx, state.catchFace.color)

  const printLeatherTypeValue = state.printLeatherType?.value

  // ウェブ先端側
  await webTop(ctx, state.web.color, state.baseModel, printLeatherTypeValue)
  // ウェブ捕球面側
  await webBottom(ctx, state.web2.color, state.baseModel, printLeatherTypeValue)
  // ブーメラン部分
  await boomerang(ctx, state.boomerang.color, printLeatherTypeValue) // 専用のstateを設けて適用
  // 背面＿人差し指-小指
  await backOfIndexToLittle(ctx, state.boomerang.color, printLeatherTypeValue) // 専用のstateを設けて適用

  undoInversion(ctx, canvasWidth)
  // 小指への刺繍
  const isEmbroideryOfChild = state.embroideries.some((x) => x.position.value === 'pinkyFingerSideBack')
  if (isEmbroideryOfChild) {
    firstMittChildFingerEmbroideryLeftThrow(
      ctx,
      state.embroideries.find((embroidery) => embroidery.position.value === 'pinkyFingerSideBack'),
      890,
      -440
    )
  }

  startInversion(ctx, canvasWidth)
  // 背面＿親指_
  await backOfThumbDrawer(ctx, state.thumb.color, state.stitch.color, printLeatherTypeValue)
  // 手首ベルト
  await wristBeltDrawer(ctx, state, printLeatherTypeValue)

  // 小指掛け紐
  littleHook(ctx, state.littleHook.color)
  // 親指掛け紐
  thumbHook(ctx, state.thumbHook.color)
  // 親指への刺繍

  // 背面＿ウェブ周り
  await backAroundWeb(ctx, state.underWeb.color, printLeatherTypeValue)
  undoInversion(ctx, canvasWidth)
  const isEmbroideryOfThumb = state.embroideries.some((x) => x.position.value === 'thumbFinger')
  if (isEmbroideryOfThumb) {
    thumbEmbroideryLeftThrow(
      ctx,
      state.embroideries.find((embroidery) => embroidery.position.value === 'thumbFinger'),
      -5,
      -80,
      9
    )
  }
  startInversion(ctx, canvasWidth)
  // ヘリ革
  edgeDrawer(ctx, state)
  // ステッチ
  stitch(ctx, state.stitch.color)
  // 指カバー
  await fingerGuardDrawer(ctx, state.fingerGuardType.value, state.indexCover.color, state.stitch.color)

  // 革紐
  laces(ctx, state.lace.color)
  undoInversion(ctx, canvasWidth)
  // 刺繍
  switch (state.baseModel.productNumber) {
    case 'APL-UR003+':
      atomsLabel(ctx, state.atomsLabel.value, 130, 90, 5, 0.82)
      atomsEngravedOfBackFace(ctx, 135, 15, 0)
      break
    default:
      //'AKG-13'
      atomsLabel(ctx, state.atomsLabel.value, 65, 25, 0, 1)
  }
}
